// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.7071 3.29289C21.5196 3.10536 21.2652 3 21 3H3C2.73478 3 2.48043 3.10536 2.29289 3.29289C2.10536 3.48043 2 3.73478 2 4V20C2 20.2652 2.10536 20.5196 2.29289 20.7071C2.48043 20.8946 2.73478 21 3 21H21C21.2652 21 21.5196 20.8946 21.7071 20.7071C21.8946 20.5196 22 20.2652 22 20V4C22 3.73478 21.8946 3.48043 21.7071 3.29289ZM4 5H7V19H4V5ZM14 5H20V19H14V5ZM12 5H9V19H12V5Z"
				fill={props.color}
			/>
		</svg>
	</>
);

export default Icon;
